export default "__VITE_PUBLIC_ASSET__924794e5__"